export const langs = [
    {
        "id" : 1,
        "img": '../assets/languages/html.png',
        "name": 'html'
    },
    {
        "id" : 2,
        "img": '../assets/languages/css.png',
        "name": 'css'
    },
    {
        "id" : 3,
        "img": '../assets/languages/javascript.png',
        "name": 'javascript'
    },
    {
        "id" : 4,
        "img": '../assets/languages/react.png',
        "name": 'react'
    },
    {
        "id" : 5,
        "img": '../assets/languages/java.png',
        "name": 'java'
    },
    {
        "id" : 6,
        "img": '../assets/languages/python.png',
        "name": 'python'
    },
    {
        "id" : 7,
        "img": '../assets/languages/mysql.png',
        "name": 'mysql'
    },
    {
        "id" : 8,
        "img": '../assets/languages/azure.png',
        "name": 'azure'
    },

];